import React from 'react';
import { Box, Button } from '@mui/material';
import Modal from '@mui/material/Modal';
import './AlertConfirm.scss';

const AlertConfirm = (_props) => {
  const { open, actionData, handleClose } = _props;

  return (
    <Modal
      open={open}
      onClose={()=>{
        handleClose(false)
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="alert-confirm">
        <Box className="alert-confirm--box">
          <div className="alert-confirm--message">
            <p>Are you sure you want to delete?</p>
          </div>
          <div className="alert-confirm--buttons">
            <div className="alert-confirm--button">
              <Button variant="contained" onClick={() => { handleClose(false) }}>
                Close
              </Button>
            </div>
            <div className="alert-confirm--button1">
              <Button variant="contained" onClick={() => { handleClose(true) }}>
                Delete
              </Button>
            </div>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default AlertConfirm;
